// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__26I8d","detailsBorder":"styles_detailsBorder__G9ifw"};